<template>
    <transition name="fade">
        <Modal
            v-if="isVisible"
            @close="$emit('close')"
        >
            <h4 class="h4 mb-24">Запись на посещение офиса</h4>
            <p class="text mb-20">
                Уважаемый клиент! Предварительная запись доступна
                для проведения операций по&nbsp;банковским продуктам физических лиц
            </p>
            <div class="flex flex-wrap items-center gap-12">
                <UIButton
                    label="Назад"
                    size="sm"
                    outlined
                    @click="$emit('close')"
                />
                <UIButton
                    label="Далее"
                    size="sm"
                    @click="$emit('ok')"
                />
            </div>
        </Modal>
    </transition>
</template>

<script>
import {defineComponent} from 'vue';
import {UIButton} from '@cibsite/ui-components-vue2';

export default defineComponent({
    name: 'OfficeRemoteRecordingConfirm',
    components: {
        Modal: () => import('@/components/UI-components/Modal/UIModal.vue'),
        UIButton,
    },
    props: {
        isVisible: {
            type: Boolean,
            default: () => false,
        },
    },
    emits: ['close', 'ok'],
});
</script>
